var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgInstagram(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 46 46' }, props),
        React.createElement("path", { d: 'M23.383 10.733c-6.567 0-11.883 5.323-11.883 11.884 0 6.567 5.322 11.883 11.883 11.883 6.567 0 11.884-5.322 11.884-11.883 0-6.567-5.323-11.884-11.884-11.884zm0 19.597a7.71 7.71 0 01-7.713-7.713 7.712 7.712 0 017.713-7.714 7.712 7.712 0 017.714 7.714 7.71 7.71 0 01-7.714 7.713z' }),
        React.createElement("path", { d: 'M32.484.144c-4.232-.197-14.714-.187-18.95 0-3.722.175-7.005 1.074-9.652 3.72C-.542 8.289.023 14.25.023 22.992c0 8.947-.498 14.77 3.859 19.126 4.44 4.439 10.488 3.858 19.126 3.858 8.863 0 11.922.006 15.056-1.207 4.26-1.655 7.476-5.463 7.79-12.303.2-4.234.189-14.714 0-18.95C45.476 5.44 41.143.543 32.485.145zm6.699 39.046c-2.9 2.9-6.923 2.641-16.23 2.641-9.584 0-13.427.142-16.23-2.67-3.23-3.214-2.646-8.375-2.646-16.2 0-10.59-1.087-18.217 9.541-18.76 2.442-.087 3.16-.116 9.308-.116l.086.058c10.214 0 18.227-1.07 18.709 9.556.109 2.424.134 3.153.134 9.29-.002 9.472.178 13.338-2.672 16.201z' }),
        React.createElement("circle", { cx: 35.65, cy: 10.35, r: 2.68 })));
}
export default SvgInstagram;
//# sourceMappingURL=Instagram.js.map